import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import type { ActionBreakdown } from '../types/analytics.types';

interface ActionsBreakdownChartProps {
  data: ActionBreakdown | undefined;
  isLoading: boolean;
}

const ACTION_LABELS: Record<string, string> = {
  create: 'Création',
  update: 'Modification',
  delete: 'Suppression',
  view: 'Consultation',
  export: 'Export',
  import: 'Import',
  login: 'Connexion',
  logout: 'Déconnexion',
  status_change: 'Changement statut',
  assign: 'Assignation',
  unassign: 'Désassignation',
};

export function ActionsBreakdownChart({ data, isLoading }: ActionsBreakdownChartProps) {
  const chartData = data?.actions.map((a) => ({
    name: ACTION_LABELS[a.action] ?? a.action,
    count: a.count,
  })) ?? [];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Répartition des actions</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="h-[300px] bg-muted animate-pulse rounded" />
        ) : chartData.length === 0 ? (
          <div className="h-[300px] flex items-center justify-center text-muted-foreground">
            Aucune action enregistrée
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chartData} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis
                dataKey="name"
                fontSize={11}
                stroke="hsl(var(--muted-foreground))"
                angle={-30}
                textAnchor="end"
                height={60}
              />
              <YAxis
                fontSize={12}
                stroke="hsl(var(--muted-foreground))"
                allowDecimals={false}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: '8px',
                  fontSize: '12px',
                }}
              />
              <Bar dataKey="count" name="Actions" fill="#B87333" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
